import { motion, type HTMLMotionProps } from 'framer-motion'
import React from 'react'

type AnimatedListItemProps = HTMLMotionProps<'div'>

export const AnimatedListItem: React.FC<AnimatedListItemProps> = ({
  children,
  transition,
  ...props
}) => (
  <motion.div
    layout='position'
    initial={{ opacity: 0, y: 4 }}
    animate={{ opacity: 1, y: 0 }}
    transition={transition ?? { duration: 0.18, ease: 'easeOut' }}
    {...props}
  >
    {children}
  </motion.div>
)
